/**
 * Utility functions for detecting react-snap pre-rendering environment
 * 
 * React-snap uses Puppeteer (headless Chrome) to crawl and pre-render pages.
 * During pre-rendering, it sets the user agent to include "ReactSnap".
 * We use this to detect pre-rendering and skip client-side behaviors that
 * would cause issues (redirects, sessionStorage access, video autoplay).
 */

/**
 * Check if the page is currently being pre-rendered by react-snap
 * @returns {boolean} True if running in react-snap pre-rendering environment
 */
export const isPrerendering = () => {
  if (typeof navigator === 'undefined') return false;
  // react-snap sets userAgent to "ReactSnap" (also set explicitly in scripts/prerender.js).
  return navigator.userAgent.includes('ReactSnap');
};

/**
 * Check if sessionStorage is available and we're not pre-rendering
 * @returns {boolean} True if sessionStorage can be safely used
 */
export const canUseSessionStorage = () => {
  if (isPrerendering()) return false;
  try {
    const testKey = '__test__';
    sessionStorage.setItem(testKey, testKey);
    sessionStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
};
